import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import BackIcon from 'resources/back-icon.svg';
import IconClose from 'resources/icon-close-support.svg';
import './PageDialogOverlay.css';

function PageDialogOverlay(props) {
  const {
    parentClassName,
    pageTitle,
    backButtonText,
    backLocation,
    headerTitle,
    closeEnable,
    children,
    closeLocation,
    scrolling
  } = props;

  return (
    <div
      className={`page-dialog-overlay-wrapper ${parentClassName}-dialog-wrapper`}
    >
      <Helmet>
        <title>{pageTitle}</title>
      </Helmet>
      <div className={`page-dialog ${parentClassName}-dialog`}>
        <div className={`page-dialog-header ${parentClassName}-dialog-header`}>
          {backButtonText && (
            <Link
              className={`page-dialog-close-button ${parentClassName}-dialog-close-button text-button`}
              to={backLocation ? backLocation : '/'}
            >
              <img src={BackIcon} alt="go back" />
              <span className="back-to-support">{backButtonText}</span>
            </Link>
          )}
          <h2 className={`page-dialog-title ${parentClassName}-dialog-title`}>
            {headerTitle}
          </h2>
          {closeEnable && (
            <Link
              className={`page-dialog-close-button ${parentClassName}-close-button text-button`}
              to={closeLocation ? closeLocation : '/'}
            >
              <img src={IconClose} alt="Close" />
            </Link>
          )}
        </div>
        <div
          className={`page-dialog-content ${parentClassName}-dialog-content`}
        >
          {scrolling ? (
            <div
              className={`page-dialog-page-scroller ${parentClassName}-dialog-page-scroller`}
            >
              {children}
            </div>
          ) : (
            children
          )}
        </div>
      </div>
    </div>
  );
}

PageDialogOverlay.propTypes = {
  parentClassName: PropTypes.string,
  pageTitle: PropTypes.string,
  backButtonText: PropTypes.string,
  backLocation: PropTypes.string,
  headerTitle: PropTypes.string,
  closeEnable: PropTypes.bool,
  children: PropTypes.any,
  closeLocation: PropTypes.string,
  scrolling: PropTypes.bool
};

export default PageDialogOverlay;
